import React from 'react';
import { NetworkProps } from './Network.type';
import { Popover, Row, Col } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@store/hooks';
import './Network.scss';
import { getNetWorkState } from '@store/meeting/meeting.slice';

const Network: React.FC<NetworkProps> = (props) => {
  const netWorkState = useAppSelector(getNetWorkState);
  const { t } = useTranslation();
  return (
    <Popover
      trigger="click"
      placement="bottom"
      overlay={
        <>
          <Row>
            <Col span={12}>{netWorkState.currentlinkQuality}</Col>
            <Col span={12} />
          </Row>
          <Row>
            <Col span={12}>{t('延迟：')}</Col>
            <Col span={6}>{netWorkState.rtt}</Col>
          </Row>
          <Row>
            <Col span={12}>{t('丢包率：')}</Col>
            <Col span={6}>{`↑${netWorkState.uplinkLoss}%`}</Col>
          </Row>
          <Row>
            <Col span={12} />
            <Col span={6}>{`↓${netWorkState.downlinkLoss}%`}</Col>
          </Row>
        </>
      }
      overlayClassName="cpn-network-popover"
    >
      <div className={`cpn-network  ${props?.className ?? ''} cpn-network-level-${netWorkState.level}`} />
    </Popover>
  );
};

export default Network;
